import * as React from 'react';
import { OTPCheckDto, OTPCheckDtoImpl } from "src/com/sixdee/crbtportal/core/dto/otp/otpcheck/otpcheckdto";
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

import {FlashMessageOTPVerificationComponentHandler, FlashMessageOTPVerificationComponentProps, FlashMessageOTPVerificationComponentState} from './flashmessageotpverificationcomponent';
import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import './flashmessageotpverification-style.css';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';
import { ButtonComponent } from '../../../../toolkit/button/buttoncomponent';
import { LoaderComponent } from '../../../../toolkit/loader/loadercomponent';
import { TextComponent } from '../../../../toolkit/text/textcomponent';
import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../../confirmrequest/confirmrequestconfirmbuttoncss';
import { LoaderWrapperComponent } from '../../loaderwrappercomponent';
import { FlashMessageOTPVerificationCSSStyle } from './falshmessageotpverificationcss';


export class FlashMessageOTPVerificationViewImpl extends UIComponentViewImpl<OTPCheckDto>
{
    otpNumber:TextComponent;
    private loaderWrapperComponent:LoaderWrapperComponent;

 
    bindHandlers()
    {   
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onConfirmClick = this.onConfirmClick.bind(this);
        this.onResendOtp = this.onResendOtp.bind(this);
    }

    draw(props: FlashMessageOTPVerificationComponentProps, state: FlashMessageOTPVerificationComponentState, cssStyle: FlashMessageOTPVerificationCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
                <div id="flashmessage-otp-web">
                    {
                        this.getWebView(props,state, cssStyle)
                    }
                </div>
                {/* <div id="flashmessage-otp-mobile">
                    {
                        this.getMobileView(props,state, cssStyle)
                    }
                </div> */}
                <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </div>
        );
    }

    getWebView(props: FlashMessageOTPVerificationComponentProps, state: FlashMessageOTPVerificationComponentState, cssStyle: FlashMessageOTPVerificationCSSStyle):JSX.Element
    {
        return(
            <>
                 <div style={cssStyle.getHeaderDivCSSStyle()}>
                     {
                     this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH &&
                             <label id="flashmessage-otp-title" style={cssStyle.getTitleCSSStyle()}>{this.getContext().getResources().getString(Strings.otp_verification)}</label>
                     }
                     {this.getContext().getUserContext().getLanguage() !== LanguageConst.ENGLISH &&
                             <label id="flashmessage-otp-title-burmese" style={cssStyle.getTitleCSSStyle()}>{this.getContext().getResources().getString(Strings.otp_verification)}</label>
                     }
                <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onCloseClick}>
                    <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()}/>
                </div>
                     
            </div>
            <div style={cssStyle.getMobileNumberCSSStyle()}>
                        <TextComponent hint={props.context.getResources().getString(Strings.otphint)} maxLength={this.getUIProps().context.getResources().getString(Strings.otp_max_length)} label={props.context.getResources().getString(Strings.enterotp)}  isDisabled={false} ref={(item: any) => this.otpNumber = item} id={"#otp"} value={""} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.enterotp)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.incorrectotp)}/>
            </div>
            <div id="flashmessage-otp-resend-button" >
                 <label onClick={this.onResendOtp} style={cssStyle.getResendButtonCSSStyle(state.isResendButtonRestricted)}>
                     {this.getContext().getResources().getString(Strings.resend_otp)}
                     <div id="flashmessage-countdown" style={{color:this.getContext().getResources().getColor(Colors.color_4)}}/>
                    
                 </label>
                
            </div>
             <div id="flashmessage-otp-confirm-button1" style={{}}>
                       
                        <div style={{width:'180px',height:'40px'}}>
                            <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.verify)}/>
                        </div>
                </div>
            </>
        );
    }

    // getMobileView(props: FlashMessageOTPVerificationComponentProps, state: FlashMessageOTPVerificationComponentState, cssStyle: FlashMessageOTPVerificationCSSStyle):JSX.Element
    // {
    //     return(
    //         <>
    //              <div style={cssStyle.getHeaderDivCSSStyle()}>
    //             <label style={cssStyle.getMobileTitleCSSStyle()}>{this.getContext().getResources().getString(Strings.otp_verification)}</label>
    //             <div style={cssStyle.getCloseIconDivCSSStyle()} onClick={this.onCloseClick}>
    //                 <img src={props.context.getResources().getImage("close_red.svg")} style={cssStyle.getCloseIconCSSStyle()}/>
    //             </div>
                     
    //         </div>
    //         <div style={cssStyle.getMobileNumberCSSStyle()}>
    //                     <TextComponent maxLength={this.getUIProps().context.getResources().getString(Strings.otp_max_length)} label={props.context.getResources().getString(Strings.enterotp)}  isDisabled={false} ref={(item: any) => this.otpNumber = item} id={"#otp"} value={""} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.enterotp)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.incorrectotp)}/>
    //         </div>
    //         <div style={{width:'100%',height:'20px',display:'flex',textAlign:'center',marginTop:'20px',marginLeft:'auto',marginRight:'auto'}}>
    //              <label onClick={this.onResendOtp} style={cssStyle.getResendButtonCSSStyle(state.isResendButtonRestricted)}>
    //                  {this.getContext().getResources().getString(Strings.resend_otp)}
    //                  <div id="countdown" style={{color:this.getContext().getResources().getColor(Colors.color_4)}}/>
                    
    //              </label>
                
    //         </div>
    //          <div style={{width:'100%',height:'40px',display:'flex',justifyContent:'center',marginTop:'30px',marginLeft:'auto',marginRight:'auto'}}>
                       
    //                     <div style={{width:'180px',height:'40px'}}>
    //                         <ButtonComponent onClick={this.onConfirmClick} style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.verify)}/>
    //                     </div>
    //             </div>
    //         </>
    //     );
    // }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    
    setErrorMsg(msg:string):void
    {
        this.otpNumber.setErrorMessage(msg);
    }
    validate(): boolean
    {
        return this.otpNumber.validate();
    }

    onResendOtp():void
    {
        (this.getUIComponentHandler() as FlashMessageOTPVerificationComponentHandler).onResendOtpClick();

    }
    onConfirmClick():void{
        (this.getUIComponentHandler() as FlashMessageOTPVerificationComponentHandler).onConfirmClick();

    }

    onCloseClick():void{
         (this.getUIComponentHandler() as FlashMessageOTPVerificationComponentHandler).onClosePopup();
    }

    getData():OTPCheckDto
    {
        let request = new OTPCheckDtoImpl();
        request.setOtp(this.otpNumber.getData());
        return request;
    }
 
  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/flashotp/flashmessageotpverificationview.tsx